import React from 'react'
import { getPrices, postPrices } from '../../../helpers/restHelpers'
import Loader from '../../loaders'
import {
    Button,
    IconButton,
    TextField,
    Typography,
} from '@material-ui/core/index'
import { strings } from '../../../localization/strings'
import { MoneyNumberFormat } from '../../../utils/formaters'
import routes from '../../router/routes'
import * as db from '../../../helpers/dbHelpers'
import InfoIcon from '@material-ui/icons/Info'
import DetailsIcon from '@material-ui/icons/NewReleases'
import Grid from '@material-ui/core/Grid/Grid'
import { getObjectKey, shippingMethods } from '../../../server/shared'
import Tooltip from '@material-ui/core/Tooltip'
import withStyles from '@material-ui/core/styles/withStyles'

const TooltipFontSizeMedium = withStyles({
    tooltip: {
        fontSize: '0.8em',
    },
})(Tooltip)

const style = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: 10,
        maxWidth: 700,
        minWidth: 300,
        opacity: 0.87,
        fontFamily: 'neutra',
        fontSize: '1.1428571428571428rem',
    },
    costTable: { border: '1px solid #f7b500', padding: 5, marginBottom: 10 },
    shippingMethodLabel: { padding: 5, marginBottom: 15, fontSize: '1.3rem' },
    costHeader: { opacity: 0.75, borderBottom: '4px solid #f7b500' },
    costRow: { display: 'flex', height: '4em', alignItems: 'center' },
    costRowItem: { flex: '1' },
    sectionContainer: { margin: 'auto' },
    sectionLabel: {
        margin: 'auto',
        fontWeight: 400,
        marginTop: 0,
        marginBottom: 20,
        fontSize: '1.6428571428571428rem',
    },
    button: {
        margin: 'auto',
        marginTop: 30,
        marginBottom: 20,
    },
}

class Component extends React.Component {
    state = {
        loader: false,
        productPrice: [],
    }

    componentDidMount() {
        this.setState({ platformId: db.getPlaftormId() })
        this.getPrices()
    }

    getPrices = () => {
        this.setState({ loader: true })
        getPrices()
            .then((response) => {
                this.setState({ productPrice: response })
            })
            .catch((error) => {
                window.showDialog(error, () =>
                    this.props.history.push(routes.orders.path)
                )
            })
            .finally(() => this.setState({ loader: false }))
    }

    handleConfirm = () => {
        this.setState({ loader: true })
        postPrices(this.state.productPrice)
            .then(() =>
                window.showDialog(
                    {
                        title: strings.saveSuccessTitle,
                        message: strings.saveSuccessDialog,
                    },
                    () => this.props.history.push(routes.orders.path)
                )
            )
            .catch(() =>
                window.showDialog({
                    title: strings.saveErrorTitle,
                    message: strings.saveErrorDialog,
                })
            )
            .finally(() => this.setState({ loader: false }))
    }

    render() {
        if (this.state.loader) return <Loader />
        return (
            <div style={style.container}>
                {this.state.productPrice.length > 0 ? (
                    [
                        ...new Set(
                            this.state.productPrice.map((x) => x.shippingMethod)
                        ),
                    ].map((shippingMethod) => (
                        <div key={shippingMethod}>
                            <div style={style.shippingMethodLabel}>
                                {
                                    strings.shippingMethods[
                                        getObjectKey(
                                            shippingMethods,
                                            shippingMethod
                                        )
                                    ]
                                }
                            </div>
                            <div style={style.costTable}>
                                <div
                                    style={{
                                        ...style.costRow,
                                        ...style.costHeader,
                                    }}
                                >
                                    <div
                                        style={{
                                            ...style.costRowItem,
                                            flex: 2,
                                        }}
                                    >
                                        {strings.productHeaderProduct}{' '}
                                    </div>
                                    <div style={style.costRowItem}>
                                        {strings.productHeaderCost}
                                        {strings.costDisclaimer ? (
                                            <TooltipFontSizeMedium
                                                title={strings.costDisclaimer}
                                            >
                                                <InfoIcon
                                                    style={{ fontSize: 16 }}
                                                />
                                            </TooltipFontSizeMedium>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                    <div style={style.costRowItem}>
                                        {strings.productHeaderPrice}
                                    </div>
                                </div>
                                {this.state.productPrice
                                    .filter(
                                        (x) =>
                                            x.shippingMethod === shippingMethod
                                    )
                                    .map((x) => (
                                        <div
                                            key={x.productId}
                                            style={style.costRow}
                                        >
                                            <div
                                                style={{
                                                    ...style.costRowItem,
                                                    opacity: 0.75,
                                                    flex: 2,
                                                }}
                                            >
                                                {x.productName}
                                                <IconButton
                                                    onClick={() =>
                                                        window.showDialog({
                                                            title: ' ',
                                                            message:
                                                                x.productDescription,
                                                        })
                                                    }
                                                >
                                                    <InfoIcon fontSize="small" />
                                                </IconButton>
                                            </div>
                                            <div style={style.costRowItem}>
                                                ${' '}
                                                {!x.productCost
                                                    ? 0
                                                    : parseFloat(
                                                          x.productCost
                                                      ).toFixed(2)}
                                            </div>
                                            <div style={style.costRowItem}>
                                                <TextField
                                                    value={parseFloat(
                                                        x.price
                                                    ).toFixed(2)}
                                                    onChange={(event) => {
                                                        this.state.productPrice.find(
                                                            (ppx) =>
                                                                ppx.productId ===
                                                                x.productId
                                                        ).price =
                                                            event.target.value
                                                        this.setState({
                                                            productPrice:
                                                                this.state
                                                                    .productPrice,
                                                        })
                                                    }}
                                                    InputProps={{
                                                        inputComponent:
                                                            MoneyNumberFormat,
                                                    }}
                                                    onBlur={() => {
                                                        if (isNaN(x.price)) {
                                                            this.state.productPrice.find(
                                                                (ppx) =>
                                                                    ppx.productId ===
                                                                    x.productId
                                                            ).price = 0
                                                            this.setState({
                                                                productPrice:
                                                                    this.state
                                                                        .productPrice,
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <div />
                )}

                {this.state.productPrice.length === 0 ? (
                    <>
                        <Grid item xs={12} sm={12}>
                            <div className="alert alert-info" role="alert">
                                <i>
                                    <DetailsIcon />
                                </i>
                                {strings.productConfigurationBanner}
                            </div>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Typography
                            variant="body1"
                            color={'primary'}
                            align={'center'}
                        >
                            <DetailsIcon
                                fontSize="large"
                                style={{ marginTop: 20 }}
                            />
                            <br/>
                            {strings.freeShippingDetails}
                        </Typography>
                    </>
                )}
                <br />

                {this.state.productPrice.length === 0 ? null : (
                    <Button
                        style={style.button}
                        label={strings.configSaveButton}
                        variant="contained"
                        color="primary"
                        onClick={this.handleConfirm}
                    >
                        {strings.configSaveButton}
                    </Button>
                )}
            </div>
        )
    }
}

export default Component
